import axios from "axios";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL + "/api",
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // send cookies automatically on every request
});

// Response interceptor to return only data
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);

const http = {
  async get(url, params = {}, headers = {}, options = {}) {
    return await apiClient.get(url, { params, headers, ...options });
  },

  async post(url, data = {}, headers = {}, options = {}) {
    return await apiClient.post(url, data, { headers, ...options });
  },

  async put(url, data = {}, headers = {}, options = {}) {
    return await apiClient.put(url, data, { headers, ...options });
  },

  async patch(url, data = {}, headers = {}, options = {}) {
    return await apiClient.patch(url, data, { headers, ...options });
  },

  async del(url, headers = {}, options = {}) {
    return await apiClient.delete(url, { headers, ...options });
  },
};

export default http;
